module.exports = __webpack_public_path__ + "static/media/Olypics_data.c46df45d.png";